import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.193 10H7.68l.966-1.667a.669.669 0 0 0-1.16-.666l-1.54 2.666a.667.667 0 0 0 .58 1H8.04L7.073 13a.67.67 0 0 0 1.16.667L9.773 11a.666.666 0 0 0-.58-1m3.28-5.193a4.667 4.667 0 0 0-8.907 1.266 2.667 2.667 0 0 0 .627 5.26.667.667 0 0 0 0-1.333 1.333 1.333 0 1 1 0-2.667.667.667 0 0 0 .667-.666 3.333 3.333 0 0 1 6.487-1.074.67.67 0 0 0 .52.44 2 2 0 0 1-.34 3.967.667.667 0 0 0 0 1.333 3.334 3.334 0 0 0 .946-6.526"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })